module.exports = __webpack_public_path__ + "dc3ae70972c56a1604a5c22d8fcfb263.jpg";